export default {
  defaultGraphYear: '',
  defaultGraphSeason: ''
}
